<template>
  <div class="invalid-feedback">
    <div
      v-for="(error, index) in errors"
      :key="error"
      :id="`${errorsIdPrefix}-error${index}`"
    >
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputErrors',
  props: {
    errors: {
      type: Array,
      required: true,
    },
    errorsIdPrefix: {
      type: String,
      required: true,
    },
  },
};
</script>
